import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_add = _resolveComponent("v-btn-add")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fill: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "d-flex pr-2 pt-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  modelValue: _ctx.searchUser,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchUser) = $event)),
                  label: "Rechercher",
                  "append-inner-icon": "$search",
                  clearable: "",
                  "onClick:appendInner": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchUser = ''))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { class: "d-flex flex-grow-0 flex-shrink-1 pl-2 align-center justify-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_add, {
                  rounded: "xl",
                  disabled: !_ctx.enableUserWrite,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitStep()))
                }, null, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, { "no-gutters": "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "pt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, {
                  modelValue: _ctx.activeTab,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeTab) = $event)),
                  class: "tab_budget_form_mobile",
                  color: "secondary"
                }, {
                  default: _withCtx(() => [
                    (_ctx.showUsers)
                      ? (_openBlock(), _createBlock(_component_v_tab, {
                          key: 0,
                          ripple: "",
                          value: "showUsers",
                          href: "#showUsers",
                          "data-cy": "selectUser-showUser-tab",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emptyMergingList()))
                        }, {
                          default: _withCtx(() => _cache[17] || (_cache[17] = [
                            _createTextVNode("Utilisateurs")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.showOrphelinUsers)
                      ? (_openBlock(), _createBlock(_component_v_tab, {
                          key: 1,
                          ripple: "",
                          value: "showOrphelinUsers",
                          href: "#showOrphelinUsers",
                          "data-cy": "selectUser-showOrphelinUsers-tab",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.emptyMergingList()))
                        }, {
                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                            _createTextVNode("Utilisateurs Orphelins")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_window, {
                  modelValue: _ctx.activeTab,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.activeTab) = $event)),
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    (_ctx.showUsers)
                      ? (_openBlock(), _createBlock(_component_v_window_item, {
                          key: 0,
                          value: "showUsers"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "mb-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      elevation: "0",
                                      class: "mr-2",
                                      rounded: "xl",
                                      disabled: !_ctx.enableUserWrite,
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectAllUsers(_ctx.filtredUsers))),
                                      "data-cy": "UserEdition-allCompanies",
                                      size: "small",
                                      variant: "flat"
                                    }, {
                                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                                        _createTextVNode(" Sélectionner tous les utilisateurs ")
                                      ])),
                                      _: 1
                                    }, 8, ["disabled"]),
                                    _createVNode(_component_v_btn, {
                                      elevation: "0",
                                      rounded: "xl",
                                      disabled: !_ctx.enableUserWrite,
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.diselectAllUsers())),
                                      "data-cy": "UserEdition-notAllCompanies",
                                      size: "small",
                                      variant: "flat"
                                    }, {
                                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                                        _createTextVNode(" Désélectionner tous les utilisateurs ")
                                      ])),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "h-100 overflow-y-auto"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_virtual_scroll, {
                                      items: _ctx.filtredUsers,
                                      height: "400",
                                      width: "1000",
                                      "item-height": "48"
                                    }, {
                                      default: _withCtx(({ item: user }) => [
                                        _createVNode(_component_v_list_item, {
                                          lines: "one",
                                          border: "",
                                          rounded: "xl",
                                          density: "compact",
                                          title: _ctx.getUserDisplayName(user),
                                          subtitle: user.email ? user.email : '',
                                          class: "mb-2",
                                          onClick: _withModifiers(($event: any) => (_ctx.editUser(user)), ["stop"])
                                        }, {
                                          prepend: _withCtx(() => [
                                            _createVNode(_component_v_checkbox, {
                                              modelValue: _ctx.selectedUsers,
                                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedUsers) = $event)),
                                              class: "pa-0 ma-0",
                                              onClick: _withModifiers(($event: any) => (_ctx.selectUser(user.id)), ["stop"]),
                                              value: _ctx.isSelectedUser(user.id)
                                            }, null, 8, ["modelValue", "onClick", "value"])
                                          ]),
                                          append: _withCtx(() => [
                                            _createVNode(_component_v_btn_next)
                                          ]),
                                          _: 2
                                        }, 1032, ["title", "subtitle", "onClick"])
                                      ]),
                                      _: 1
                                    }, 8, ["items"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.showOrphelinUsers)
                      ? (_openBlock(), _createBlock(_component_v_window_item, {
                          key: 1,
                          value: "showOrphelinUsers"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  class: "mb-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      elevation: "0",
                                      class: "mr-2",
                                      rounded: "xl",
                                      variant: "flat",
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectAllUsers(_ctx.orphelinUsers))),
                                      disabled: !_ctx.enableUserWrite,
                                      "data-cy": "UserEdition-allCompanies",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                                        _createTextVNode(" Sélectionner tous les utilisateurs ")
                                      ])),
                                      _: 1
                                    }, 8, ["disabled"]),
                                    _createVNode(_component_v_btn, {
                                      elevation: "0",
                                      rounded: "xl",
                                      variant: "flat",
                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.diselectAllUsers())),
                                      disabled: !_ctx.enableUserWrite,
                                      "data-cy": "UserEdition-notAllCompanies",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                                        _createTextVNode(" Désélectionner tous les utilisateurs ")
                                      ])),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_virtual_scroll, {
                                      items: _ctx.orphelinUsers,
                                      height: "400",
                                      width: "1000",
                                      "item-height": "48"
                                    }, {
                                      default: _withCtx(({ item: user }) => [
                                        _createVNode(_component_v_list_item, {
                                          class: "mb-2",
                                          lines: "two",
                                          border: "",
                                          rounded: "xl",
                                          density: "compact",
                                          title: _ctx.getUserDisplayName(user),
                                          subtitle: user.email ? user.email : ''
                                        }, {
                                          prepend: _withCtx(() => [
                                            _createVNode(_component_v_checkbox, {
                                              modelValue: _ctx.selectedUsers,
                                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedUsers) = $event)),
                                              class: "pa-0 ma-0",
                                              disabled: !_ctx.enableUserWrite,
                                              onClick: _withModifiers(($event: any) => (_ctx.selectUser(user.id)), ["stop"]),
                                              value: _ctx.isSelectedUser(user.id)
                                            }, null, 8, ["modelValue", "disabled", "onClick", "value"])
                                          ]),
                                          append: _withCtx(() => [
                                            _createVNode(_component_v_btn_trash, {
                                              modelValue: user.id,
                                              "onUpdate:modelValue": ($event: any) => ((user.id) = $event),
                                              disabled: !_ctx.enableUserWrite,
                                              onClick: _withModifiers(($event: any) => (_ctx.confirmToDeleteOrphelin(user)), ["stop"])
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onClick"])
                                          ]),
                                          _: 2
                                        }, 1032, ["title", "subtitle"])
                                      ]),
                                      _: 1
                                    }, 8, ["items"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      (_ctx.confirmDeleteDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 0,
            modelValue: _ctx.confirmDeleteDialog,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.confirmDeleteDialog) = $event)),
            title: "Suppression Utilisateur",
            onValid: _cache[14] || (_cache[14] = ($event: any) => (_ctx.deleteOrphelin(_ctx.toDeleteUser.id))),
            "max-width": "40vw"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h4", null, "Voulez-vous supprimer l'utilisateur " + _toDisplayString(_ctx.getUserDisplayName(_ctx.toDeleteUser)) + " ?", 1)
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.multiDeleteDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 1,
            modelValue: _ctx.multiDeleteDialog,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.multiDeleteDialog) = $event)),
            title: "Suppression Utilisateurs",
            onValid: _cache[16] || (_cache[16] = ($event: any) => (_ctx.deleteOrphelinUsers())),
            "max-width": "40vw"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h4", null, "Voulez-vous supprimer " + _toDisplayString(_ctx.selectedUsers.length) + " utilisateur(s) ?", 1)
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}